import { z } from 'zod';
import { OMNICHANNEL_MAX_REDES, OMNICHANNEL_MAX_REDES_MESSAGE } from './constants';

export const omnichannelFormSchema = z
  .object({
    tipoLocalizacao: z.nullable(z.string()),
    produtos: z.array(z.string()),
    periodoSemanas: z.number(),
    tipoGtin: z.string(),
    redes: z.array(z.string()),
    cidade: z.array(z.string()),
    uf: z.array(z.string()),
  })
  .superRefine((values, ctx) => {
    if (values.tipoGtin === 'ESPECIFICOS' && values.produtos.length === 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['produtos'], message: 'Selecione ao menos 1 produto' });
    }
    if (values.redes.length === 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['redes'], message: 'Selecione ao menos 1 rede' });
    }
    if (values.redes.length > OMNICHANNEL_MAX_REDES) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['redes'], message: OMNICHANNEL_MAX_REDES_MESSAGE });
    }
    if (values.periodoSemanas === 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['periodoSemanas'], message: 'Selecione o período' });
    }
    if (values.tipoLocalizacao === 'UF' && values.uf.length === 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['uf'], message: 'Selecione a UF' });
    }
    if (values.tipoLocalizacao === 'CIDADE' && values.cidade.length === 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['cidade'], message: 'Selecione a cidade' });
    }
  });

export type OmnichannelFormSchema = z.infer<typeof omnichannelFormSchema>;
